var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeIcSize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 260 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke: #437063;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 11px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "text"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 260,
    height: 260
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 130,
    y1: 50,
    x2: 130,
    y2: 210
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "107.63 72.37 130 50 152.37 72.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "152.37 187.63 130 210 107.63 187.63"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 50,
    y1: 130,
    x2: 210,
    y2: 130
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "72.37 152.37 50 130 72.37 107.63"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "187.63 107.63 210 130 187.63 152.37"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeIcSize);
export default __webpack_public_path__ + "static/media/HE-IC-Size.5c0815e0be45335495c85be053d88e61.svg";
export { ForwardRef as ReactComponent };